// ============================================================================
// EXPLUS CLEANING — SITE CONTENT (edit here to update the website)
// ----------------------------------------------------------------------------
// • Business info (phone/email/links): constants just below.
// • Services, Reviews, Benefits, Cities, FAQs, Stats: arrays in this file.
// • Gallery photos: edit the GALLERY array (swap the image URLs).
// • Before/After photos: fill the BEFORE_AFTER array (leave empty = placeholders).
// No other files need changing for routine content updates.
// ============================================================================
export const PHONE = "(253) 534-6626";
export const PHONE_HREF = "tel:+12535346626";
export const EMAIL = "expluscleaning@gmail.com";
export const EMAIL_HREF = "mailto:expluscleaning@gmail.com";
export const SMS_HREF = "sms:+12535346626";

// Social media — official Explus Cleaning pages.
export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/people/Explus-Cleaning-LLC/61593140084079/",
  instagram: "https://www.instagram.com/expluscleaning",
  whatsapp:
    "https://wa.me/12535346626?text=Hi%20Explus%20Cleaning!%20I%27d%20like%20to%20request%20a%20free%20estimate.",
};

// Trust wording — easy to update before launch.
// NOTE: Do NOT add "Licensed" or "Bonded" until confirmed.
export const TRUST_ITEMS = [
  "Free Estimates",
  "Flexible Scheduling",
  "Locally Owned",
  "Fully Insured",
  "Residential & Commercial",
];
export const INSURED_LABEL = "Fully Insured";
export const LICENSED_INSURED = "Licensed & Insured in WA";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?auto=format&fit=crop&w=1900&q=80",
  residential:
    "https://images.unsplash.com/photo-1647381518264-97ff1835026f?auto=format&fit=crop&w=1000&q=80",
  office:
    "https://images.unsplash.com/photo-1549637642-90187f64f420?auto=format&fit=crop&w=1000&q=80",
  airbnb:
    "https://images.unsplash.com/photo-1542681575-352258e0c854?auto=format&fit=crop&w=1000&q=80",
  about:
    "https://images.unsplash.com/photo-1713110824336-f78c320dcf8e?auto=format&fit=crop&w=1200&q=80",
};

export const SERVICES = [
  {
    icon: "House",
    title: "Residential Cleaning",
    desc: "Regular cleaning for houses, apartments and condos — kitchens, bathrooms, floors, bedrooms and common areas.",
    image: IMAGES.residential,
  },
  {
    icon: "Sparkle",
    title: "Deep Cleaning",
    desc: "A detailed top-to-bottom cleaning for spaces that need extra attention, buildup removal and a fresh reset.",
  },
  {
    icon: "Package",
    title: "Move-In / Move-Out",
    desc: "Detailed cleaning for tenants, homeowners, landlords and property managers before or after a move.",
  },
  {
    icon: "Buildings",
    title: "Office Cleaning",
    desc: "Reliable cleaning for offices, small businesses and commercial spaces with flexible scheduling.",
    image: IMAGES.office,
  },
  {
    icon: "Bed",
    title: "Airbnb Turnovers",
    desc: "Fast and dependable turnover cleaning to prepare short-term rentals for the next guest.",
    image: IMAGES.airbnb,
  },
  {
    icon: "Broom",
    title: "Custom Cleaning",
    desc: "Need something specific? We build a cleaning plan around your property, priorities and schedule.",
  },
];

export const BENEFITS = [
  { n: "01", title: "Reliable", desc: "We arrive ready to work and respect your time and property." },
  { n: "02", title: "Detailed", desc: "We focus on the areas that make the biggest difference." },
  { n: "03", title: "Flexible", desc: "One-time, weekly, biweekly and custom scheduling options." },
  { n: "04", title: "Local", desc: "Proudly serving Everett and nearby Washington communities." },
];

export const GOOGLE_RATING = { score: "5.0", count: 9 };
export const REVIEWS_URL = "https://maps.app.goo.gl/FPvY5ocQ8LQqRHab9?g_st=ic";

export const REVIEWS = [
  {
    text: "Excellent house cleaning service! The team was very professional, friendly, and paid close attention to detail. They did an amazing job and left the house looking spotless, fresh, and organized. They arrived on time, worked efficiently, and made sure everything was done properly. I'm very happy with the results and would definitely recommend this company to anyone looking for reliable and high-quality house cleaning services. I will definitely use them again!",
    author: "Marcos Antonio Claros",
  },
  {
    text: "Cleaned my place well nice fast and professional",
    author: "DuneWalkerz",
  },
  {
    text: "I had a great experience with Explus Cleaning LLC. The team was friendly, efficient, and did a very thorough job. They took their time with the details and the difference was noticeable immediately. The entire process was simple and stress-free. I will definitely use their services again.",
    author: "Diana",
  },
  {
    text: "Excellent service from Explus Cleaning LLC. They were punctual, professional, and paid close attention to detail. Everything was left clean and organized, and communication was easy throughout the entire process. I would definitely recommend them to anyone looking for a reliable cleaning company.",
    author: "Fausto Claros",
  },
  {
    text: "Great experience with Explus Cleaning LLC! They were professional, reliable, and did an amazing job. Everything was left clean and fresh, and they paid attention to the small details. I would definitely recommend them to anyone looking for a dependable cleaning service. ⭐⭐⭐⭐⭐",
    author: "Josué Cecilio Tejada Ramírez",
  },
];

export const SERVICE_OPTIONS = [
  "Residential Cleaning",
  "Deep Cleaning",
  "Move-In / Move-Out Cleaning",
  "Office Cleaning",
  "Airbnb Turnover",
  "Other",
];

export const FREQUENCY_OPTIONS = ["One-Time", "Weekly", "Biweekly", "Monthly", "Not Sure"];

const U = (id, w = 900) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

// Premium gallery — temporary professional stock photos, replace with real projects later.
export const GALLERY = [
  { src: U("1512916194211-3f2b7f5f7de3"), category: "Residential", alt: "Luxury modern kitchen" },
  { src: U("1502005097973-6a7082348e28"), category: "Residential", alt: "Bright white kitchen island" },
  { src: U("1754574741164-a41418029cfb"), category: "Deep Cleaning", alt: "Elegant modern bathroom" },
  { src: U("1723984790027-ffe34efb18f6"), category: "Residential", alt: "Spa-style bathroom with tub" },
  { src: U("1643949700215-e61cdca053f7"), category: "Residential", alt: "Modern bathroom vanity" },
  { src: U("1560185893-a55cbc8c57e8"), category: "Residential", alt: "Serene bedroom retreat" },
  { src: U("1616486029423-aaa4789e8c9a"), category: "Residential", alt: "Sunlit modern bedroom" },
  { src: U("1633505899118-4ca6bd143043"), category: "Residential", alt: "Bright living room with large windows" },
  { src: U("1618220179428-22790b461013"), category: "Residential", alt: "Styled living room lounge" },
  { src: U("1758523670739-0d26a3ee976d"), category: "Residential", alt: "Professional cleaner vacuuming living room" },
  { src: U("1758273238415-01ec03d9ef27"), category: "Deep Cleaning", alt: "Cleaner mopping a bright floor" },
  { src: U("1581578731548-c64695cc6952"), category: "Deep Cleaning", alt: "Detailed window cleaning" },
  { src: U("1631193816258-28b44b21e78b"), category: "Commercial", alt: "Clean open-plan office desks" },
  { src: U("1556761175-4b46a572b786"), category: "Commercial", alt: "Modern commercial workspace" },
  { src: U("1760278042013-e6a4866c4c81"), category: "Commercial", alt: "Tidy home office setup" },
  { src: U("1679494422425-844a04e11f5d"), category: "Airbnb", alt: "Airbnb bedroom ready for guests" },
  { src: U("1697462247864-338e7eba8c4c"), category: "Airbnb", alt: "Fresh linens and folded towels" },
  { src: U("1580256081112-e49377338b7f"), category: "Carpet Cleaning", alt: "Professional carpet cleaning in hallway" },
  { src: U("1742483359033-13315b247c74"), category: "Carpet Cleaning", alt: "Steam carpet deep cleaning" },
  { src: U("1630699375895-fe5996d163ee"), category: "Move-Out", alt: "Spotless empty apartment" },
  { src: U("1630699144919-681cf308ae82"), category: "Move-Out", alt: "Move-out ready room" },
];

export const GALLERY_FILTERS = [
  "All",
  "Residential",
  "Commercial",
  "Deep Cleaning",
  "Move-Out",
  "Airbnb",
  "Carpet Cleaning",
];

export const SERVICE_CITIES = [
  "Everett",
  "Mukilteo",
  "Lynnwood",
  "Edmonds",
  "Mill Creek",
  "Bothell",
  "Marysville",
  "Lake Stevens",
  "Mountlake Terrace",
  "Shoreline",
];

export const FAQS = [
  { q: "How do I request a free estimate?", a: "Just fill out the quote form on this page or call us at (253) 534-6626. We'll get back to you quickly to discuss your needs and provide a free, no-obligation estimate." },
  { q: "Do I need to be home during the cleaning?", a: "Not at all. Many of our clients provide access instructions and go about their day. You're welcome to be home if you prefer — whatever makes you most comfortable." },
  { q: "Do you bring your own cleaning supplies?", a: "Yes. We arrive fully equipped with professional-grade supplies and equipment. If you'd like us to use specific products, just let us know." },
  { q: "How often should I schedule cleaning?", a: "It depends on your lifestyle and space. We offer one-time, weekly, biweekly and monthly plans, and we're happy to recommend a schedule that fits your home or business." },
  { q: "Do you clean Airbnb properties?", a: "Absolutely. We provide fast, reliable turnover cleaning to keep your short-term rental guest-ready between stays." },
  { q: "Do you offer one-time cleaning?", a: "Yes. Whether it's a deep clean, a move-in/move-out, or a special occasion, we're glad to help with one-time cleanings." },
  { q: "What areas do you serve?", a: "We proudly serve Everett and surrounding communities including Mukilteo, Lynnwood, Edmonds, Mill Creek, Bothell, Marysville, Lake Stevens, Mountlake Terrace and Shoreline." },
];

export const STATS = [
  { value: 100, suffix: "%", label: "Satisfaction Focused" },
  { value: 10, suffix: "+", label: "Communities Served" },
  { value: 6, suffix: "", label: "Cleaning Services" },
  { value: 24, suffix: "h", label: "Fast Quote Response" },
];

// Before & After — leave EMPTY to show "Your Future Explus Cleaning Project"
// placeholders. To go live, add objects: { before: "url", after: "url", label: "Kitchen deep clean" }
export const BEFORE_AFTER = [];
